export default __webpack_public_path__ + "static/media/vip-icon.52e99db8.webp";